import React, { useState } from "react";
import { toast } from "sonner";
import api, { formatApiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { ScanFace, Loader2 } from "lucide-react";

const GESTAO = ["SUPERADMIN", "DIRECAO", "COORDENACAO"];

export const RemoveFaceButton = ({ student, onDone }) => {
  const { user } = useAuth();
  const [busy, setBusy] = useState(false);
  if (!GESTAO.includes(user?.role) || !(student.face_id || student.face_photo_path)) return null;
  const run = async () => {
    if (!window.confirm(`Remover a biometria facial de ${student.full_name}? Ele deixará de ser reconhecido no quiosque até ser fotografado de novo.`)) return;
    setBusy(true);
    try {
      await api.delete(`/students/${student.id}/face-enroll`);
      toast.success("Biometria removida");
      onDone();
    } catch (e) { toast.error(formatApiError(e.response?.data?.detail)); } finally { setBusy(false); }
  };
  return (
    <Button variant="outline" size="sm" onClick={run} disabled={busy} className="border-rose-200 text-rose-700 hover:bg-rose-50" data-testid="remove-face-btn">
      {busy ? <Loader2 className="mr-1.5 h-4 w-4 animate-spin" /> : <ScanFace className="mr-1.5 h-4 w-4" />}Remover biometria
    </Button>
  );
};
